import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Routes from '@/routers/router'
import { ConfigProvider } from 'antd';
import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

ConfigProvider.config({
  // prefixCls: 'custom',
  theme: {
    primaryColor: '#36A096',
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider>
      <Routes />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
